import React, { useState, useEffect, useRef } from 'react'
import { useNavigation, CommonActions } from '@react-navigation/native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { useSelector } from 'react-redux'
import { fetchAuthSession } from 'aws-amplify/auth'

import {
    StatusBar,
    StyleSheet,
    Text,
    View,
    TouchableOpacity,
    TextInput,
    Image,
    Dimensions,
    TouchableWithoutFeedback,
    ScrollView,
    ImageBackground,
    ScrollViewBase,
    FlatList,
    ActivityIndicator,
    Platform,
} from 'react-native'
import { useFunctions } from '../../learning/hooks/useFunctions'
import { eventEmitter } from '../../../utils/functions.utils'
import { BackHandler } from 'react-native'
import {
    module_structure_update,
    save_assessment_request,
    save_progress_training_request,
    save_survey_request,
} from '../../learning/services'
import {
    get_evaluation_by_id,
    get_course_by_id,
    update_course_local,
    update_status_local_content,
    save_assessment_local,
    update_course_certificate,
    update_content_certificate,
    save_survey_local,
    get_learning,
    LEARNING_STORE_NAMES,
    update_evaluation_failed_questions,
    increment_evaluation_attempts_count,
    get_assessment_by_evaluation_id,
} from '../../../db/learning/index'
import { LEARNING_STATUS, OPTIONS } from '../../learning/constants'
import { openDB } from '../../../db/indexDB'
import { Loader } from '../Components/Loader'
import NetInfo from '@react-native-community/netinfo'
import { apiUrl } from '../../../config/config'
import { AntDesign, EvilIcons, Feather } from '@expo/vector-icons'
import theme from '../../../../theme'
import { useDeviceStore } from '../../../redux/zustand/deviceInfoStore'
import styles from './surveyStyles'
import { TrackingServices } from '../../../../database/tracking.database'
import { getLanguage } from '../../appBar/context/LocalizationContext'
import { placeholderLearning } from '../Constants'
import { useBottomSheet } from '../context/BottomSheetContext'
import {
    BottomSheetAlert,
    BottomSheetBackAlert,
} from '../../modals/BottomSheetAlert'
import { LinearGradient } from 'expo-linear-gradient'
import { colorIcon, GamificationTheme } from '../../../../themeConstants'
import { useFetchCourses } from '../../learning/hooks/useFetchCourses'
import { emitProgressUpdate } from '../../learning/progressBus'
import { updateGlobalVersion } from '../../../db/indexDB'
import { UserServices } from '../../../../database/user.database'
import { ModalNextCourseOfflineNotDownloaded } from '../../modals/ModalNextCourseOfflineNotDownloaded'
import { searchFile } from '../Components/ImageWIthZoom'
import { INPUT_TYPE } from '../../../utils/Constants'
// import { request_get_training_courses_home } from '@/services/courses.services'
import { request_get_training_courses_home } from '../../../services/courses.services.ts'
import { useLearningStore } from '../../../redux/zustand/useLearningCourse.ts'
import { ThumbsUpIcon, ThumbsDownIcon, StarIcon } from 'phosphor-react-native'
import { save_assessment_progress } from '../../../services/learning.services'
import {
    mark_assessment_as_sent,
    update_evaluation_current_attempt_id,
    update_evaluation_partial_answers,
    update_evaluation_attempt_date_created,
} from '../../../../db-sqlite/repositories/learning.repository'
import { isSP } from '../AppConstants'

const { width } = Dimensions.get('window')
const isWeb = Platform.OS === 'web'

function isPair(value) {
    return value % 2 === 0
}
// Helper para sanear números y evitar NaN/Infinity
const safeNumber = (value, fallback = 0) => {
    const n = typeof value === 'string' ? parseFloat(value) : value
    return Number.isFinite(n) ? n : fallback
}

// Import del hook del modal solo en web
let useSurveyModal = null
if (Platform.OS === 'web') {
    try {
        const SurveyModalModule = require('./SurveyModal.web')
        useSurveyModal = SurveyModalModule.useSurveyModal
    } catch (e) {
        // Si no existe el módulo, useSurveyModal queda null
    }
}

export default function Survey({ route }) {
    const { languageFile } = getLanguage()
    const {
        evaluation,
        next_content,
        current_modul,
        option,
        course_id,
        array_courses,
        courseItem,
    } = route.params

    const { updateStatusModule, find_current_module, find_next_module } =
        useFunctions()
    const { setReloadFetchCourses, isFetching } = useFetchCourses()
    const insets = useSafeAreaInsets()

    const currentCourse_store = useLearningStore((state) => state.currentCourse)
    const updateCourseProgress_store = useLearningStore(
        (state) => state.updateCourseProgress,
    )

    // Detectar si estamos en modal web y obtener cierre expuesto por el wrapper
    const surveyModalCtx = useSurveyModal ? useSurveyModal() : null
    const isWebModal = surveyModalCtx?.isWebModal || false
    const closeWebModal = surveyModalCtx?.closeModal
    const navigation = useNavigation()
    const [currentQuestion, setCurrentQuestion] = useState(0)
    const [score, setScore] = useState(0)
    const [assessmentResult, setAssessmentResult] = useState({
        isApproved: false,
        totalScore: 0,
        userScorePercentage: 0,
    })
    const [showScore, setShowScore] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [currentEvaluation, setCurrentEvaluation] = useState(null)
    const [evalError, setEvalError] = useState(null)

    const [course, setCourse] = useState(currentCourse_store || courseItem || null)
    const [selectedOptions, setSelectedOptions] = useState([])
    const [database, setDatabase] = useState(null)
    const [is_connect, setConnect] = useState(false)
    const [labelComplet, setlabelComplet] = useState([]) // Estado para almacenar las respuestas del usuario en caso de complete_blanks
    const [positionLabel, setpositionLabel] = useState(null)
    const [rating, setRating] = useState(0)
    const [liked, setLiked] = useState({ active: null })

    // Nuevas keys de evaluación
    const attemptIdRef = useRef(null) // ID de sesión para envíos parciales
    const [remainingAttempts, setRemainingAttempts] = useState(null)
    const [failedQuestions, setFailedQuestions] = useState([])
    const originalQuestionsRef = useRef([]) // preguntas completas sin filtrar, para reintentos
    // IDs de preguntas ya enviadas al backend en la sesión actual (allow_partial_submission)
    const submittedQuestionsRef = useRef(new Set())
    // Cantidad de preguntas ya respondidas al momento de cargar la evaluación (fija, para el contador)
    const initialSubmittedCountRef = useRef(0)

    // Obtener la evaluación al cargar el componente
    const surveyData = currentEvaluation
        ? currentEvaluation.questions && currentEvaluation.questions.length > 0
            ? currentEvaluation.questions
            : currentEvaluation.survey && currentEvaluation.survey.length > 0
              ? currentEvaluation.survey.flatMap((s) => s.questions || [])
              : []
        : null

    const { deviceId } = useDeviceStore()

    const { openBottomSheet, closeBottomSheet } = useBottomSheet()

    const path = course_id ? `courses/${course_id}` : null

    const scrollRef = useRef(null)

    const resetScroll = () => {
        if (!scrollRef || !scrollRef.current) return
        scrollRef.current?.scrollTo({ y: 0, animated: true }) // vuelve al inicio
    }

    const handleAnswer = async (selectedAnswer) => {
        const answer = surveyData[currentQuestion]
        const questionId = answer._id

        // Verificar el tipo de pregunta
        if (
            answer.input_type[0]['title'] === 'single_choice' ||
            answer.input_type[0]['title'] === 'single_choice_image'
        ) {
            // Para preguntas de opción única, deselecciona todas las opciones antes de seleccionar la nueva
            const updatedQuestions = currentEvaluation.questions.map(
                (question, index) => {
                    if (index === currentQuestion) {
                        return {
                            ...question,
                            secondary_actions: question.secondary_actions.map(
                                (option) => ({
                                    ...option,
                                    is_selected: option._id === selectedAnswer._id,
                                }),
                            ),
                        }
                    }
                    return question
                },
            )

            // Actualizar el estado de la evaluación con las preguntas actualizadas
            setCurrentEvaluation({
                ...currentEvaluation,
                questions: updatedQuestions,
            })

            // Almacenar la opción seleccionada
            setSelectedOptions((prevState) => ({
                ...prevState,
                [questionId]: [selectedAnswer],
            }))
        } else {
            if (
                answer.input_type[0]['title'] === 'multiple_choice' ||
                answer.input_type[0]['title'] === 'multiple_choice_image'
            ) {
                // Para preguntas de opción múltiple, permite seleccionar o deseleccionar múltiples opciones
                const updatedQuestions = currentEvaluation.questions.map(
                    (question, index) => {
                        if (index === currentQuestion) {
                            return {
                                ...question,
                                secondary_actions: question.secondary_actions.map(
                                    (option) => {
                                        if (option._id === selectedAnswer._id) {
                                            // Alternar la selección de la opción
                                            return {
                                                ...option,
                                                is_selected: !option.is_selected,
                                            }
                                        }
                                        return option
                                    },
                                ),
                            }
                        }
                        return question
                    },
                )

                // Actualizar el estado de la evaluación con las preguntas actualizadas
                setCurrentEvaluation({
                    ...currentEvaluation,
                    questions: updatedQuestions,
                })

                // Obtener las opciones seleccionadas
                const selectedOptionsForQuestion = updatedQuestions[
                    currentQuestion
                ].secondary_actions.filter((option) => option.is_selected)

                // Almacenar las opciones seleccionadas
                setSelectedOptions((prevState) => ({
                    ...prevState,
                    [questionId]: selectedOptionsForQuestion,
                }))
            } else {
                // si entra aca es type input
                console.log('selectedAnswer', selectedAnswer)
                setSelectedOptions((prevState) => ({
                    ...prevState,
                    [questionId]: [{ input: selectedAnswer }],
                }))
            }
        }
    }

    let modal_text =
        surveyData && surveyData[currentQuestion]
            ? surveyData[currentQuestion].text_modal
            : ''

    const [showInterModal, setShowInterModal] = useState(false)

    const validateCorrectAnswers = (question) => {
        let correctData = {
            allCorrect: false,
            score: 0,
            maxPossibleScore: 0,
        }
        if (!currentEvaluation || !question) return correctData

        correctData.allCorrect = true
        switch (question.input_type[0]?.type) {
            case INPUT_TYPE.COMPLETE_BLANKS:
                const labelCompString =
                    labelComplet.join(' ').toLocaleLowerCase() || ''
                const correctWords = question.text_correct.toLocaleLowerCase() // Respuesta correcta

                if (labelCompString != correctWords) {
                    correctData.allCorrect = false
                }
                break
            case INPUT_TYPE.SINGLE_CHOICE:
            case INPUT_TYPE.SINGLE_CHOICE_IMAGE:
            case INPUT_TYPE.MULTIPLE_CHOICE:
            case INPUT_TYPE.MULTIPLE_CHOICE_IMAGE:
                question.secondary_actions.forEach((action) => {
                    if (action.correct && !action.is_selected) {
                        correctData.allCorrect = false
                    }
                    if (action.is_selected && !action.correct) {
                        correctData.allCorrect = false
                    }
                })
                break
            default:
                console.log('Unknown question type')
                break
        }

        //? Sumo puntaje por pregunta, para el total
        correctData.maxPossibleScore = question.score ? question.score : 0

        //? Sumo puntaje solo si respondí todo bien
        if (correctData.allCorrect === true) {
            correctData.score = question.score ? question.score : 0
        }
        return correctData
    }

    let { allCorrect } = currentEvaluation
        ? validateCorrectAnswers(currentEvaluation.questions[currentQuestion])
        : false

    const [optionsToHighlight, setOptionsToHighlight] = useState([])

    let showCorrect =
        surveyData && surveyData[currentQuestion]?.show_correct
            ? surveyData[currentQuestion]?.show_correct
            : false

    // let showCorrect = true
    const [waiting, setWaiting] = useState(false)

    const showCorrectAnswer = () => {
        setWaiting(true)
        let answeredQuestion = Object.keys(selectedOptions).find(
            (o) => o === surveyData[currentQuestion]._id,
        )
        if (answeredQuestion != undefined) {
            let options = []
            for (let q of selectedOptions[answeredQuestion]) {
                let _id = q._id
                options.push(_id)
            }
            setOptionsToHighlight(options)
        }
        const timer = setTimeout(() => {
            highlightTimeOut()
        }, 2000)

        return () => clearTimeout(timer)
        // console.log('OPCIONES A RESALTAR ===>', selectedOptions)
    }

    const highlightTimeOut = () => {
        setOptionsToHighlight([])
        setNextQuestion()
    }

    const handleNextQuestion = async () => {
        const answer = surveyData[currentQuestion]
        const questionId = answer._id
        const allQuestionsAnswered = selectedOptions[questionId]?.length > 0

        if (allQuestionsAnswered) {
            if (showCorrect) {
                showCorrectAnswer()
            } else if (answer.text_modal && answer.text_modal.length > 0) {
                setShowInterModal(true)
            } else {
                setNextQuestion()
            }
            setlabelComplet([])
            return
        } else {
            let image = require('../../../../assets/evaluations/evaluationSelectOption.png')
            let title = languageFile.select_option
            let desc = languageFile.select_one_answer
            let button = languageFile.back
            // En web dentro del modal de Survey evitamos abrir BottomSheet global
            if (isWeb && isWebModal) {
                alert(desc)
            } else {
                openBottomSheet(
                    <BottomSheetAlert
                        image={image}
                        title={title}
                        desc={desc}
                        button={button}
                        closeBottomSheet={closeBottomSheet}
                    />,
                )
            }
            //alert('Por favor, seleccione al menos una respuesta para cada pregunta.')
        }
    }

    const setNextQuestion = () => {
        resetScroll()
        setWaiting(false)
        setShowInterModal(false)
        const answer = surveyData[currentQuestion]
        const questionId = answer._id
        const selectedAnswer = selectedOptions[questionId][0]
        const option_selected = answer['secondary_actions'].find(
            (item) => item._id == selectedAnswer._id,
        )

        // Si el curso está Pendiente, pasarlo a En curso al responder la primera pregunta
        if (course?.status === LEARNING_STATUS.PENDIENTE) {
            console.log('[Survey] update_course_local: PENDIENTE → IN_PROGRESS: ', course._id)
            update_course_local(database, course._id, LEARNING_STATUS.IN_PROGRESS, null).catch(() => {})
        }

        // Marcar la pregunta actual como respondida y persistir en BD local (online + offline)
        const answeredQuestionId = surveyData[currentQuestion]._id
        submittedQuestionsRef.current.add(answeredQuestionId)
        const updatedPartialIds = [...submittedQuestionsRef.current]
        update_evaluation_partial_answers(
            currentEvaluation._id,
            updatedPartialIds,
        ).catch(() => {})

        if (option_selected?.go_to) {
            if (option_selected.finish) {
                save_evaluation(selectedOptions)
            } else {
                const nextQuestionIndex = Number(option_selected.go_to) - 1
                setCurrentQuestion(nextQuestionIndex)
                if (currentEvaluation.allow_partial_submission && is_connect) {
                    console.log('1- Sending partial answer...')
                    sendPartialAnswer(selectedOptions).catch(() => {})
                }
            }
        } else {
            console.log('Entro al else para avanzar')
            if (currentQuestion + 1 >= surveyData.length) {
                console.log('Deberia guardar')
                save_evaluation(selectedOptions)
            } else {
                setCurrentQuestion(currentQuestion + 1)
                if (currentEvaluation.allow_partial_submission && is_connect) {
                    console.log('2- Sending partial answer...')
                    sendPartialAnswer(selectedOptions).catch(() => {})
                }
            }
        }
    }

    // Envía respuestas acumuladas al servidor cuando allow_partial_submission = true.
    // No bloquea la UI — los errores se ignoran silenciosamente.
    const sendPartialAnswer = async (answers) => {
        try {
            const session = await fetchAuthSession()
            const authToken = session.tokens?.accessToken?.toString()
            if (!authToken) return
            const data = {
                authToken,
                evaluation_id: currentEvaluation._id ?? null,
                course_id: course_id ?? null,
                content_id: current_modul ? current_modul['_id'] : null,
                answers,
                attempt_id: attemptIdRef.current,
            }

            const resp = await save_assessment_progress(data, null)

            const respSinglePartial = resp?.response?.single
            if (respSinglePartial?.attempt_id) {
                attemptIdRef.current = respSinglePartial.attempt_id
                // Persistir en DB para sobrevivir reinicios de la app mientras la evaluación está en curso
                await update_evaluation_current_attempt_id(
                    currentEvaluation._id,
                    respSinglePartial.attempt_id,
                ).catch(() => {})
                if (respSinglePartial.attempt_date_created) {
                    await update_evaluation_attempt_date_created(
                        currentEvaluation._id,
                        respSinglePartial.attempt_date_created,
                    ).catch(() => {})
                }
            }
            // Si el servidor devuelve partial_anmswers actualizado, persistir en BD local
            if (
                Array.isArray(respSinglePartial?.partial_anmswers) &&
                respSinglePartial.partial_anmswers.length > 0
            ) {
                respSinglePartial.partial_anmswers.forEach((id) =>
                    submittedQuestionsRef.current.add(id),
                )
                await update_evaluation_partial_answers(currentEvaluation._id, [
                    ...submittedQuestionsRef.current,
                ]).catch(() => {})
            }
        } catch (_) {}
    }

    const save_evaluation = async (answers) => {
        setShowScore(true)
        setIsLoading(true)
        try {
            const db = await openDB()
            const netInfoState = await NetInfo.fetch()
            const isConnected =
                netInfoState.isConnected && netInfoState.isInternetReachable

            // 1. Mergear respuestas previas + nuevas (siempre, para calcular score correcto en reintentos)
            const prevAssessment = await get_assessment_by_evaluation_id(
                db,
                currentEvaluation._id,
            )
            const previousAnswers = prevAssessment?.answers || {}
            const mergedAnswers = { ...previousAnswers, ...(answers || {}) }

            // 2. Guardar en BD local siempre — un registro nuevo por intento
            const localRecord = {
                _id: Date.now(),
                evaluation_id: currentEvaluation._id ?? null,
                course_id: course_id ?? null,
                content_id: current_modul ? current_modul['_id'] : null,
                answers: mergedAnswers,
            }
            await save_assessment_local(db, localRecord)

            // 3. Intentar enviar online inmediatamente si hay conexión
            let sent = false
            if (isConnected) {
                try {
                    const session = await fetchAuthSession()
                    const authToken = session.tokens?.accessToken?.toString() || ''
                    const data_update_devices_users = {
                        authToken,
                        device_key: deviceId,
                        table: 'training_courses_caches',
                    }
                    const requestData = {
                        authToken,
                        evaluation_id: currentEvaluation._id ?? null,
                        course_id: course_id ?? null,
                        content_id: current_modul ? current_modul['_id'] : null,
                        answers: mergedAnswers,
                        attempt_id: attemptIdRef.current,
                    }

                    const save_assessment = await save_assessment_progress(
                        requestData,
                        data_update_devices_users,
                    )

                    if (
                        save_assessment &&
                        save_assessment.status &&
                        save_assessment.response &&
                        save_assessment.response.status
                    ) {
                        sent = true
                        await mark_assessment_as_sent(localRecord._id)

                        const respSingle = save_assessment.response.single
                        setAssessmentResult(respSingle)

                        if (respSingle.attempt_id)
                            attemptIdRef.current = respSingle.attempt_id
                        if (respSingle.remaining_attempts != null)
                            setRemainingAttempts(respSingle.remaining_attempts)
                        if (Array.isArray(respSingle.failed_questions)) {
                            setFailedQuestions(respSingle.failed_questions)
                            update_evaluation_failed_questions(
                                db,
                                currentEvaluation._id,
                                respSingle.failed_questions,
                            ).catch(() => {})
                        }
                        setScore(safeNumber(respSingle?.userScorePercentage, 0))

                        const pdf = respSingle.certificate
                        if (pdf) {
                            if (course_id)
                                await update_course_certificate(
                                    database,
                                    course_id,
                                    pdf,
                                )
                            if (current_modul?._id)
                                await update_content_certificate(
                                    database,
                                    current_modul['_id'],
                                    pdf,
                                )
                        }
                    }
                } catch (sendError) {
                    console.error(
                        'save_evaluation - error al enviar online:',
                        sendError,
                    )
                }
            }

            // 4. Si no se pudo enviar (offline o fallo): calcular score local con respuestas mergeadas
            if (!sent) {
                const allQuestions =
                    originalQuestionsRef.current.length > 0
                        ? originalQuestionsRef.current
                        : currentEvaluation.questions
                const isApproved = isApprovedEvaluation(
                    { ...currentEvaluation, questions: allQuestions },
                    mergedAnswers,
                )
                setAssessmentResult(isApproved)
                setScore(safeNumber(isApproved?.userScorePercentage))

                const failedOffline = getFailedQuestionsOffline(
                    { ...currentEvaluation, questions: allQuestions },
                    mergedAnswers,
                )
                setFailedQuestions(failedOffline)
                update_evaluation_failed_questions(
                    db,
                    currentEvaluation._id,
                    failedOffline,
                ).catch(() => {})
            }

            // 5. Limpieza final (siempre, sin importar si se envió o no)
            if (!isWeb) {
                attemptIdRef.current = null
                update_evaluation_current_attempt_id(
                    db,
                    currentEvaluation._id,
                    null,
                ).catch(() => {})
                increment_evaluation_attempts_count(db, currentEvaluation._id).catch(
                    () => {},
                )
                submittedQuestionsRef.current = new Set()
                initialSubmittedCountRef.current = 0
                update_evaluation_partial_answers(
                    db,
                    currentEvaluation._id,
                    [],
                ).catch(() => {})
            }

            try {
                setReloadFetchCourses()
            } catch {}
        } catch (error) {
            console.error('save_evaluation error:', error)
        } finally {
            setIsLoading(false)
        }
    }

    //TODO REVISAR OFFLINE
    const handRestart = async () => {
        console.log('🚀 --------- handRestart called')
        // guardo la res de las estrellas y el like
        const courseToUpdate = course || currentCourse_store || courseItem
        console.log('🚀 --------- courseToUpdate:', courseToUpdate)
        if (!courseToUpdate?._id) {
            console.error('❌ No valid course found')
            if (isWeb && isWebModal && typeof closeWebModal === 'function') {
                closeWebModal()
            } else {
                navigation.goBack()
            }
            return
        }

        try {
            const netInfoState = await NetInfo.fetch()
            const connect = netInfoState.isConnected

            setConnect(connect)

            let approved = assessmentResult.isApproved
            if (option === OPTIONS.OPTION_COURSE) {
                // es un curso
                console.log('--------------ENTRO AL OPTION COURSE--------------')
                try {
                    await update_course_local(
                        database,
                        course._id,
                        approved
                            ? LEARNING_STATUS.COMPLETED
                            : LEARNING_STATUS.REPROBADO,
                        score.toString(),
                    )
                } catch (error) {
                    console.log(
                        '213 Error handRestart - update_course_local: => ',
                        error,
                    )
                }
                console.log('Actualizo assestment Result ==>', score)
                assessmentResult.userScorePercentage = score

                const params_course = {
                    item: course,
                    array_cursos: array_courses,
                }

                // ✅ Actualizar el store con el nuevo estado
                updateCourseProgress_store({
                    assessmentResult: score,
                    status: approved
                        ? LEARNING_STATUS.COMPLETED
                        : LEARNING_STATUS.REPROBADO,
                })

                if (approved) {
                    console.log('240 -------- rating: ', rating)

                    openModaDownloadCourseOffline(course._id)
                }
                // En web si está dentro de modal, cerrar el modal y navegar desde el wrapper
                // Invalidar versión local para forzar refetch fresco desde la API
                try {
                    const db = await openDB()
                    await updateGlobalVersion(
                        db,
                        LEARNING_STORE_NAMES.LEARNING_VERSION,
                        null,
                    )
                } catch (e) {
                    console.warn('Error invalidating local learning version:', e)
                }

                // Notificar al progressBus para que LearningHome refresque
                try {
                    emitProgressUpdate({
                        courseId: course?._id,
                        updated: [
                            {
                                courseId: course?._id,
                                status: approved
                                    ? LEARNING_STATUS.COMPLETED
                                    : LEARNING_STATUS.REPROBADO,
                            },
                        ],
                    })
                } catch (e) {
                    console.warn('Error emitting progress update:', e)
                }

                if (isWeb && isWebModal && typeof closeWebModal === 'function') {
                    closeWebModal({
                        course_id: course?._id || route.params.course_id,
                        courseItem: route.params.courseItem || course,
                    })
                } else {
                    navigation.goBack()
                    // try {
                    //     navigation.dispatch(
                    //         CommonActions.reset({
                    //             index: 0,
                    //             routes: [{ name: 'Course', params: params_course }],
                    //         }),
                    //     )
                    // } catch (e) {
                    //     navigation.navigate('Course', params_course)
                    // }
                }
            } else if (option === OPTIONS.OPTION_MODULE) {
                // es un contenido
                const payload = []

                const update_current_modul = {
                    module: current_modul,
                    status: approved
                        ? LEARNING_STATUS.COMPLETED
                        : LEARNING_STATUS.REPROBADO,
                }

                if (score !== 0) {
                    update_current_modul.assessmentResult = score.toString()
                }

                payload.push(update_current_modul)

                if (
                    next_content &&
                    next_content.status === LEARNING_STATUS.BLOCKED &&
                    approved
                ) {
                    const contenido = {
                        module: next_content,
                        status: LEARNING_STATUS.PENDIENTE,
                    }

                    payload.push(contenido)
                }

                let moduls_status = await module_structure_update(
                    database,
                    payload,
                    courseItem,
                )

                let status_course = courseItem.status

                if (
                    status_course !== LEARNING_STATUS.COMPLETED &&
                    courseItem.evaluations.length === 0
                ) {
                    console.log('acaa actualizo status final de curso')
                    const isCompleted = moduls_status.every(
                        (module) => module.status === LEARNING_STATUS.COMPLETED,
                    )
                    if (isCompleted) {
                        status_course = LEARNING_STATUS.COMPLETED
                    }
                }

                if (netInfoState.isConnected) {
                    const session = await fetchAuthSession()
                    const authToken = session.tokens?.accessToken?.toString()
                    const data = {
                        course_id: course_id,
                        course_status: status_course,
                        moduls: JSON.stringify(moduls_status),
                        authToken: authToken,
                    }

                    const data_update_devices_users = {
                        authToken: authToken,
                        device_key: deviceId,
                        table: 'training_courses_caches',
                    }

                    const res_save_progress = await save_progress_training_request(
                        data,
                        data_update_devices_users,
                    )
                } else {
                    // TODO revisar progresos pendientes ?
                }
                await update_status_local_content(payload)

                const params = {
                    item: course,
                    array_cursos: array_courses,
                }

                // Invalidar versión local para forzar refetch fresco desde la API
                try {
                    const dbVersion = await openDB()
                    await updateGlobalVersion(
                        dbVersion,
                        LEARNING_STORE_NAMES.LEARNING_VERSION,
                        null,
                    )
                } catch (e) {
                    console.warn(
                        'Error invalidating local learning version (module):',
                        e,
                    )
                }

                // Notificar al progressBus para que LearningHome refresque
                try {
                    emitProgressUpdate({
                        courseId: course_id,
                        updated: payload.map((p) => ({
                            moduleId: p.module?._id,
                            status: p.status,
                        })),
                    })
                } catch (e) {
                    console.warn('Error emitting progress update (module):', e)
                }

                if (isWeb && isWebModal && typeof closeWebModal === 'function') {
                    let newcourse = { ...course, status: status_course }
                    closeWebModal({
                        course_id: course?._id || route.params.course_id,
                        courseItem: newcourse || route.params.courseItem,
                    })
                } else {
                    // Pop Survey (actual) + Module (debajo) para volver al Course existente
                    // sin pushear una nueva instancia. CourseHome gana foco y su useFocusEffect
                    // dispara fetchDataNew() para mostrar los statuses actualizados.
                    navigation.pop(2)
                }
            }

            try {
                const evaluationId = evaluation
                    ? typeof evaluation === 'string'
                        ? JSON.parse(evaluation)[0]
                        : evaluation[0]
                    : null

                const update = [
                    {
                        evaluation_id: evaluationId._id,
                        score: score,
                    },
                ]

                if (approved) {
                    //* aca tengo el rating
                    console.log('326 -------- rating: ', rating)
                }
            } catch (error) {
                console.log(
                    '311 Error en update_assesment_result_local_evaluation: ',
                    error,
                )
            }

            try {
                // llamar el endpoint que responde la encuesta

                if (
                    currentEvaluation.survey &&
                    currentEvaluation.survey.length > 0
                ) {
                    if (rating !== 0 && liked.active !== null) {
                        const survey = currentEvaluation.survey[0]

                        const data_answers = [liked, rating]

                        const data_answers_res = data_answers.map((answer) => {
                            return {
                                questionText: answer.question_text,
                                optionSelectedText: [answer.label],
                                optionSelectedId: [answer._id],
                            }
                        })

                        if (netInfoState.isConnected) {
                            const session = await fetchAuthSession()
                            const authToken = session.tokens?.accessToken?.toString()

                            const data = {
                                authToken: authToken,
                                course_id: course_id,
                                survey_id: survey._id,
                                answers: data_answers_res,
                            }

                            let save_assessment = await save_survey_request(data)
                        } else {
                            const db = await openDB()
                            console.log('Guardo en local')
                            console.log(
                                'estoy sin conexion guardo encuesta en local',
                            )
                            const data = {
                                _id: survey._id,
                                course_id: course_id,
                                answers: JSON.stringify(data_answers_res),
                            }
                            const res = await save_survey_local(db, data)
                        }
                    } else {
                        console.log(
                            '379 ------------- No respondio la encuesta no envio nada... validar ?',
                        )
                    }
                }
            } catch (error) {
                console.log(
                    '350 Error en update_assesment_result_local_evaluation: ',
                    error,
                )
            }

            // No bloquear la UI con loader global al cerrar
        } catch (error) {
            // No bloquear la UI con loader global al cerrar
            console.error('Entro al catch de handRestart: ', error)
            throw new Error('Error en handRestart 237:  ', error)
        }
    }

    const openModaDownloadCourseOffline = async (currentCourseId) => {
        try {
            const db = await openDB()
            const { courses: array_courses } = await get_learning(db)

            const netInfoState = await NetInfo.fetch()

            if (netInfoState.isConnected) {
                console.log('Hay conexion, no hace falta abrir el modal')
                return
            }

            if (!array_courses || array_courses.length === 0) {
                console.log('480 - No hay cursos')
                return
            }

            // dentro del array de cursos, itero los cursos y busco dentro de la key
            // blocked_by el currentCourseId
            // si aprove el curso, desbloqueo el curso que esta bloqueado por el currentCourseId

            const findCourseBlocked = array_courses.filter((course) =>
                course.blocked_by.includes(currentCourseId),
            )
            console.log(
                '🚀 ~ openModaDownloadCourseOffline ~ findCourseBlocked:',
                findCourseBlocked,
            )

            if (findCourseBlocked && findCourseBlocked.length === 0) {
                console.log('No hay cursos bloqueados por este curso')
                return
            }

            const courseBlocked = findCourseBlocked[0]
            const courseBlockedId = courseBlocked._id

            const versionName =
                LEARNING_STORE_NAMES.COURSES_ZIP_VERSION + courseBlockedId
            const oldVersion = await UserServices.getGlobalVersion(versionName)

            if (!oldVersion && oldVersion !== 0) {
                let image = require('../../../../assets/unlockedCourse.png')
                let title = '¡Nuevo curso desbloqueado!'
                let description =
                    'Para continuar y/o descargarlo en modo offline, necesitas tener conexión.'

                openBottomSheet(
                    <ModalNextCourseOfflineNotDownloaded
                        image={image}
                        title={title}
                        description={description}
                        button={true}
                        buttonDelete={false}
                        buttonCancel={false}
                        closeBottomSheet={closeBottomSheet}
                    />,
                    undefined,
                    false,
                    false,
                    false,
                )
            }
        } catch (error) {
            console.error('🚀 ~ openModaDownloadCourseOffline ~ error:', error)
        }
    }

    const handleRetry = () => {
        const questionsForRetry =
            currentEvaluation.retry_only_failed && failedQuestions.length > 0
                ? originalQuestionsRef.current.filter((q) =>
                      failedQuestions.includes(q._id),
                  )
                : originalQuestionsRef.current

        setCurrentEvaluation((prev) => ({ ...prev, questions: questionsForRetry }))
        setCurrentQuestion(0)
        setSelectedOptions([])
        setShowScore(false)
        setScore(0)
        setlabelComplet([])
        setOptionsToHighlight([])
        setAssessmentResult({
            isApproved: false,
            totalScore: 0,
            userScorePercentage: 0,
        })
        attemptIdRef.current = null
        // update_evaluation_current_attempt_id(database, currentEvaluation._id, null).catch(() => {})
        update_evaluation_current_attempt_id(currentEvaluation._id, null).catch(
            () => {},
        )
        submittedQuestionsRef.current = new Set()
        initialSubmittedCountRef.current = 0
        // Limpiar partial_anmswers en BD local: el nuevo intento empieza desde cero
        update_evaluation_partial_answers(currentEvaluation._id, []).catch(() => {})
    }

    /**
     * renderiza el componente modal de aprobado, desaprobado o pendiente al finalizar una evaluacion
     */
    const ShowBottons = () => {
        let data_survey = []

        if (currentEvaluation.survey && currentEvaluation.survey.length > 0) {
            const surveys = currentEvaluation.survey[0]

            if (surveys.questions) {
                const survey_questions = surveys['questions']

                data_survey = survey_questions.map((question) => {
                    return {
                        _id: question._id,
                        question: question.title,
                        type: question.type,
                        secondary_actions: question.secondary_actions,
                    }
                })
                console.log(
                    '----------------- 🚀 ~ file: survey.js:387 ~ ShowBottons ~ data_survey2:',
                    data_survey[0]['secondary_actions'],
                )
            }
        }

        const canRepeat = !!currentEvaluation.can_repeat
        const maxRetry = currentEvaluation.max_retry_attempts
            ? parseInt(currentEvaluation.max_retry_attempts)
            : null
        const canRetry =
            canRepeat &&
            (maxRetry === null ||
                remainingAttempts === null ||
                remainingAttempts > 0)

        // if (is_connect) {
        const backgroundColor = assessmentResult.isApproved
            ? 'rgb(2, 135, 85)'
            : 'rgb(218, 41, 28)'
        const linearGradientStart = assessmentResult.isApproved
            ? theme.colors.linearGradientGreenStart
            : theme.colors.linearGradientRedStart
        const linearGradientEnd = assessmentResult.isApproved
            ? theme.colors.linearGradientGreenEnd
            : theme.colors.linearGradientRedEnd

        const imagePath = assessmentResult.isApproved
            ? require('../SurveyBlock/assets/evaluationApproved.png')
            : require('../SurveyBlock/assets/evaluationDisapproved.png')
        const feedbackTitle = assessmentResult.isApproved
            ? languageFile.congratulations
            : languageFile.try_again
        const feedbackDescription = assessmentResult.isApproved
            ? languageFile.passed_the_evaluation
            : languageFile.start_the_course_again

        const setTypeIcons = (
            type,
            secondary_actions,
            question_id,
            question_text,
        ) => {
            switch (type) {
                case 'like':
                    return (
                        <View style={styles.containerEditIcon}>
                            {secondary_actions.map((option) => {
                                if (option.label === 'Si') {
                                    return (
                                        <TouchableOpacity
                                            onPress={() =>
                                                setLiked({
                                                    active: true,
                                                    _id: option._id,
                                                    label: option.label,
                                                    question_id,
                                                    question_text,
                                                })
                                            }
                                            style={styles.editIcon}
                                        >
                                            {liked.active === true ? (
                                                // <AntDesign name='like1' size={45} color={colorIcon} />
                                                <ThumbsUpIcon
                                                    size={45}
                                                    color={colorIcon}
                                                    weight={'fill'}
                                                />
                                            ) : (
                                                // <AntDesign name='like2' size={45} color={colorIcon} />
                                                <ThumbsUpIcon
                                                    size={45}
                                                    color={colorIcon}
                                                    weight={'regular'}
                                                />
                                            )}
                                        </TouchableOpacity>
                                    )
                                } else {
                                    return (
                                        <TouchableOpacity
                                            onPress={() =>
                                                setLiked({
                                                    active: false,
                                                    _id: option._id,
                                                    label: option.label,
                                                    question_id,
                                                    question_text,
                                                })
                                            }
                                            style={styles.editIcon}
                                        >
                                            {liked.active === false ? (
                                                // <AntDesign name='dislike1' size={45} color={colorIcon} />
                                                <ThumbsDownIcon
                                                    size={45}
                                                    color={colorIcon}
                                                    weight={'fill'}
                                                />
                                            ) : (
                                                // <AntDesign name='dislike2' size={45} color={colorIcon} />
                                                <ThumbsDownIcon
                                                    size={45}
                                                    color={colorIcon}
                                                    weight={'regular'}
                                                />
                                            )}
                                        </TouchableOpacity>
                                    )
                                }
                            })}
                            {/* <TouchableOpacity onPress={() => setLiked(true)} style={styles.editIcon}>
                                    {liked === true ? <AntDesign name="like1" size={45} color="white" /> : <AntDesign name="like2" size={45} color="white" />}
                                </TouchableOpacity>
                                <View style={{ width: 45 }}></View>
                                <TouchableOpacity onPress={() => setLiked(false)} style={styles.editIcon}>
                                    {liked === false ? <AntDesign name="dislike1" size={45} color="white" /> : <AntDesign name="dislike2" size={45} color="white" />}
                                </TouchableOpacity> */}
                        </View>
                    )

                case 'star':
                    return (
                        <View style={styles.containerStarIcon}>
                            {/* {[...Array(secondary_actions.length)].map((_, index) => (
                                    <TouchableWithoutFeedback key={index} onPress={() => setRating(index + 1)}>
                                        <AntDesign
                                            name={index < rating ? 'star' : 'staro'}
                                            size={45}
                                            color={index < rating ? theme.colors.alert : 'white'}
                                        />
                                    </TouchableWithoutFeedback>
                                ))} */}

                            {secondary_actions.map((option, index) => (
                                <TouchableOpacity
                                    key={index}
                                    onPress={() =>
                                        setRating({
                                            index: index + 1,
                                            _id: option._id,
                                            label: option.label,
                                            question_id,
                                            question_text,
                                        })
                                    }
                                >
                                    {/* <AntDesign
                                        name={index < rating.index ? 'star' : 'staro'}
                                        size={45}
                                        color={index < rating.index ? theme.colors.alert : 'white'}
                                    /> */}
                                    <StarIcon
                                        color={theme.colors.alert}
                                        weight={
                                            index < rating.index ? 'fill' : 'regular'
                                        }
                                        size={45}
                                    />
                                </TouchableOpacity>
                            ))}
                        </View>
                    )

                default:
                    break
            }
        }

        return (
            <LinearGradient
                style={[
                    styles.container,
                    isWeb && {
                        height: '100%',
                        paddingHorizontal: '5%',
                        paddingTop: isWebModal ? '6%' : insets.top,
                        paddingBottom: '1%',
                        alignContent: 'center',
                    },
                ]}
                colors={[linearGradientStart, linearGradientEnd]}
                start={{ x: 0, y: 1 }}
                end={{ x: 0, y: 0 }}
            >
                <View
                    style={[
                        styles.feedbackContainer,
                        isWeb && { maxWidth: 750, alignSelf: 'center' },
                    ]}
                >
                    {/* <StatusBar backgroundColor={linearGradientEnd} barStyle='light-content' /> */}
                    <View style={[styles.feedbackAssetContainer]}>
                        <Image
                            style={[
                                styles.feedbackAsset,
                                { width: 145, height: 145 },
                                { marginBottom: 16 },
                                isWeb && {
                                    width: 200,
                                    height: 200,
                                    marginBottom: 16,
                                },
                            ]}
                            source={imagePath}
                            resizeMode='contain'
                            resizeMethod='resize'
                        />
                    </View>

                    <View style={styles.feedbackInfoContainer}>
                        <Text style={styles.feedbackTitle}>{feedbackTitle}</Text>
                        <Text style={[styles.feedbackDescription]}>
                            {feedbackDescription}
                        </Text>
                        {assessmentResult.isApproved === false && (
                            <Text style={styles.feedbackScore}>
                                {(() => {
                                    const canRepeatVal =
                                        !!currentEvaluation?.can_repeat
                                    const maxRetryVal =
                                        currentEvaluation?.max_retry_attempts
                                            ? parseInt(
                                                  currentEvaluation.max_retry_attempts,
                                              )
                                            : null
                                    if (!canRepeatVal)
                                        return 'No puedes reintentar esta evaluación.'
                                    if (maxRetryVal === null) return ''
                                    return `Intentos restantes: ${remainingAttempts ?? '0'} de ${maxRetryVal}`
                                })()}
                            </Text>
                        )}
                        <Text style={styles.feedbackScore}>
                            {languageFile.score} {Math.round(safeNumber(score, 0))}%
                        </Text>

                        {assessmentResult.isApproved && data_survey.length > 0 && (
                            <View style={styles.surveyBlock}>
                                {data_survey.map((survey) => {
                                    return (
                                        <React.Fragment key={survey._id}>
                                            <Text style={styles.feedbackQuestion}>
                                                {survey.question}
                                            </Text>
                                            {setTypeIcons(
                                                survey.type,
                                                survey.secondary_actions,
                                                survey._id,
                                                survey.question,
                                            )}
                                        </React.Fragment>
                                    )
                                })}
                            </View>
                        )}
                    </View>

                    <View style={[styles.buttonContainer, styles.paddingTop]}>
                        <TouchableOpacity
                            onPress={handRestart}
                            style={{
                                backgroundColor: 'white',
                                paddingVertical: 10,
                                paddingHorizontal: 35,
                                borderRadius: 100,
                            }}
                        >
                            {isFetching ? (
                                <ActivityIndicator
                                    size='small'
                                    color={linearGradientStart}
                                    animating={true}
                                />
                            ) : (
                                <Text
                                    style={[
                                        styles.borderButtonText,
                                        { color: linearGradientStart },
                                    ]}
                                >
                                    {languageFile.close}
                                </Text>
                            )}
                        </TouchableOpacity>
                    </View>
                </View>
            </LinearGradient>
        )
    }

    const normalizeEvalId = (evaluationParam) => {
        try {
            if (!evaluationParam) return null
            if (typeof evaluationParam === 'string') {
                // Puede venir como ID directo o como string JSON de array de IDs
                try {
                    const parsed = JSON.parse(evaluationParam)
                    if (Array.isArray(parsed)) return parsed[0] || null
                } catch {}
                return evaluationParam
            }
            if (Array.isArray(evaluationParam)) {
                const first = evaluationParam[0]
                if (!first) return null
                if (typeof first === 'string') return first
                if (typeof first === 'object') return first?._id || null
                return null
            }
            if (typeof evaluationParam === 'object')
                return evaluationParam?._id || null
            return null
        } catch {
            return null
        }
    }

    const closeToCourse = (reason) => {
        try {
            setEvalError(reason || 'evaluation_not_found')
        } catch {}
        // Preferir cerrar modal web si existe
        if (isWeb && closeWebModal) {
            try {
                closeWebModal({ course_id, courseItem })
            } catch {}
            return
        }
        // Mobile/native: ir directo al tab root (Main) para mantener footer visible y evitar loops de back
        try {
            navigation.dispatch(
                CommonActions.reset({ index: 0, routes: [{ name: 'Main' }] }),
            )
            // Asegurar que el footer/tab bar reaparezca tras cerrar la evaluación
            try {
                eventEmitter.emit('showFooter')
            } catch {}
        } catch {}
    }

    const fetchEvaluation = async () => {
        console.log(
            '[Survey] fetchEvaluation called with evaluation param:',
            evaluation,
        )
        try {
            const netInfoState = await NetInfo.fetch()
            const connect = netInfoState.isConnected
            setConnect(connect)
            const db = await openDB()
            setDatabase(db)
            console.log('🚀 ~llega esto en ~ evaluation:', evaluation)
            const evaluationId = normalizeEvalId(evaluation)
            console.log('🚀 ~ fetchEvaluation ~ evaluationId:', evaluationId)
            if (!evaluationId) {
                console.warn('[Survey] Missing evaluationId; closing modal/screen')
                return closeToCourse('missing_evaluation_id')
            }
            let get_evaluation = await get_evaluation_by_id(db, evaluationId)
            // console.log('Raw get_evaluation from DB:', get_evaluation)

            // Si no está en DB, buscar en courseItem.evaluations (para web o casos donde no se guardó)
            if (!get_evaluation && courseItem && courseItem.evaluations) {
                console.log(
                    '[Survey] Evaluation not in DB, searching in courseItem.evaluations',
                )
                get_evaluation = courseItem.evaluations.find(
                    (ev) => ev._id === evaluationId,
                )
                console.log('Found in courseItem.evaluations:', get_evaluation)
            }

            if (get_evaluation) {
                // Parse stringified fields
                if (typeof get_evaluation.type_assessment === 'string') {
                    try {
                        while (typeof get_evaluation.type_assessment === 'string') {
                            get_evaluation.type_assessment = JSON.parse(
                                get_evaluation.type_assessment,
                            )
                        }
                    } catch (e) {
                        console.log('Parse error type_assessment:', e)
                        get_evaluation.type_assessment = []
                    }
                }
                // Ensure type_assessment is an array
                if (!Array.isArray(get_evaluation.type_assessment)) {
                    get_evaluation.type_assessment = []
                }
                if (typeof get_evaluation.questions === 'string') {
                    try {
                        while (typeof get_evaluation.questions === 'string') {
                            get_evaluation.questions = JSON.parse(
                                get_evaluation.questions,
                            )
                        }
                    } catch (e) {
                        console.log('Parse error questions:', e)
                        get_evaluation.questions = []
                    }
                }
                if (typeof get_evaluation.survey === 'string') {
                    try {
                        while (typeof get_evaluation.survey === 'string') {
                            get_evaluation.survey = JSON.parse(get_evaluation.survey)
                        }
                    } catch (e) {
                        console.log('Parse error survey:', e)
                        get_evaluation.survey = []
                    }
                }
                // Ensure survey is an array
                if (!Array.isArray(get_evaluation.survey)) {
                    get_evaluation.survey = []
                }
                // Ensure questions is an array
                if (!Array.isArray(get_evaluation.questions)) {
                    get_evaluation.questions = []
                }
                // console.log('Parsed get_evaluation:', get_evaluation)
                // Parse secondary_actions in each question
                get_evaluation.questions.forEach((question) => {
                    if (question && typeof question.secondary_actions === 'string') {
                        try {
                            question.secondary_actions = JSON.parse(
                                question.secondary_actions,
                            )
                        } catch {}
                    }
                    if (!Array.isArray(question.secondary_actions)) {
                        question.secondary_actions = []
                    }
                })

                // Parse secondary_actions in survey questions
                if (Array.isArray(get_evaluation.survey)) {
                    get_evaluation.survey.forEach((surveyItem) => {
                        if (surveyItem && Array.isArray(surveyItem.questions)) {
                            surveyItem.questions.forEach((question) => {
                                if (
                                    question &&
                                    typeof question.secondary_actions === 'string'
                                ) {
                                    try {
                                        question.secondary_actions = JSON.parse(
                                            question.secondary_actions,
                                        )
                                    } catch {}
                                }
                                if (!Array.isArray(question.secondary_actions)) {
                                    question.secondary_actions = []
                                }
                            })
                        }
                    })
                }

                try {
                    TrackingServices.addTracking(
                        get_evaluation['_id'],
                        'get_evaluation',
                        'learning_evaluations',
                    )
                } catch (error) {
                    console.error(error)
                }

                // LOG: Estado de randomización de la evaluación
                // console.log('🎲 [RANDOM DEBUG] Evaluación:', get_evaluation.name || get_evaluation._id)
                // console.log('🎲 [RANDOM DEBUG] questions_random:', get_evaluation.questions_random)
                // console.log('🎲 [RANDOM DEBUG] random:', get_evaluation.random)
                // console.log('🎲 [RANDOM DEBUG] Tipo de questions_random:', typeof get_evaluation.questions_random)
                // console.log('🎲 [RANDOM DEBUG] Tipo de random:', typeof get_evaluation.random)
                // console.log('🎲 [RANDOM DEBUG] Total preguntas antes de randomizar:', get_evaluation['questions'].length)

                const normalizeBoolean = (value) => {
                    if (
                        value === true ||
                        value === 'true' ||
                        value === 1 ||
                        value === '1'
                    )
                        return true
                    if (
                        value === false ||
                        value === 'false' ||
                        value === 0 ||
                        value === '0' ||
                        value === null ||
                        value === undefined
                    )
                        return false
                    return false
                }

                const questionsRandomNormalized = normalizeBoolean(
                    get_evaluation.questions_random,
                )
                const randomNormalized = normalizeBoolean(get_evaluation.random)
                const shouldRandomizeQuestions =
                    questionsRandomNormalized || randomNormalized

                // SIEMPRE randomiza las opciones de respuesta (secondary_actions)
                // console.log('🎲 [RANDOM DEBUG] Randomizando opciones de respuesta (secondary_actions)...')
                for (var i = 0; i < get_evaluation['questions'].length; i++) {
                    let questions = get_evaluation['questions'][i]
                    if (Array.isArray(questions['secondary_actions'])) {
                        // console.log(`🎲 [RANDOM DEBUG] Pregunta ${i + 1}: randomizando ${questions['secondary_actions'].length} opciones`)

                        if (shouldRandomizeQuestions) {
                            questions['secondary_actions'].sort(function (a, b) {
                                return 0.5 - Math.random()
                            })
                        }
                    }
                }

                // Randomizar el orden de las PREGUNTAS solo si está configurado
                // Normalizar valores: puede venir como 1/0, "true"/"false", true/false

                // console.log('🎲 [RANDOM DEBUG] questions_random normalizado:', questionsRandomNormalized)
                // console.log('🎲 [RANDOM DEBUG] random normalizado:', randomNormalized)
                // console.log('🎲 [RANDOM DEBUG] ¿Debe randomizar PREGUNTAS?', shouldRandomizeQuestions)

                if (
                    Array.isArray(get_evaluation.questions) &&
                    shouldRandomizeQuestions
                ) {
                    // console.log('🎲 [RANDOM DEBUG] ✅ RANDOMIZANDO orden de preguntas')
                    get_evaluation['questions'].sort(function (a, b) {
                        return 0.5 - Math.random()
                    })
                } else {
                    // console.log('🎲 [RANDOM DEBUG] ❌ NO randomizando orden de preguntas')
                }

                if (
                    get_evaluation.count_questions &&
                    parseInt(get_evaluation.count_questions) > 0
                ) {
                    get_evaluation['questions'] = get_evaluation['questions'].slice(
                        0,
                        parseInt(get_evaluation.count_questions),
                    )
                }

                // Guardar preguntas completas (post-slice) para poder reconstruir en reintentos
                originalQuestionsRef.current = [...get_evaluation.questions]

                // Inicializar failed_questions si vienen en la evaluacion (desde el backend)
                let evalFailedQuestions = []
                if (get_evaluation.failed_questions) {
                    try {
                        evalFailedQuestions =
                            typeof get_evaluation.failed_questions === 'string'
                                ? JSON.parse(get_evaluation.failed_questions)
                                : Array.isArray(get_evaluation.failed_questions)
                                  ? get_evaluation.failed_questions
                                  : []
                    } catch {}
                }
                if (evalFailedQuestions.length > 0)
                    setFailedQuestions(evalFailedQuestions)

                // Si retry_only_failed=true y hay preguntas fallidas, mostrar solo las que respondió mal.
                // No se depende de attempts_count (no disponible offline): si failed_questions tiene IDs
                // es porque ya hubo al menos un intento previo.
                if (
                    get_evaluation.retry_only_failed &&
                    evalFailedQuestions.length > 0
                ) {
                    get_evaluation.questions = get_evaluation.questions.filter((q) =>
                        evalFailedQuestions.includes(q._id),
                    )
                }

                // Filtrar preguntas ya respondidas en el intento en curso (partial_anmswers)
                // Funciona tanto online (viene del API) como offline (persistido localmente)

                // Si la evaluación tiene guardado parcial y el intento en curso expiró,
                // limpiar el estado local para que el backend cree un nuevo intento al enviar.
                // Prioridad: attempt_expiry_minutes > attempt_expiry_days > default (7 días)
                if (
                    get_evaluation.allow_partial_submission &&
                    get_evaluation.partial_anmswers?.length > 0
                ) {
                    // Valida que sea una fecha real (descarta null, 0, epoch y strings inválidos)
                    const parsedAttemptDate = new Date(get_evaluation.attempt_date_created)
                    const isValidAttemptDate =
                        get_evaluation.attempt_date_created &&
                        !isNaN(parsedAttemptDate.getTime()) &&
                        parsedAttemptDate.getFullYear() > 1970

                    if (!isValidAttemptDate) {
                        // No tenemos fecha válida — la guardamos ahora para que el timer arranque desde este momento
                        const now = new Date().toISOString()
                        console.log('[ExpiryCheck] attempt_date_created ausente o inválido — guardando fecha actual:', now)
                        get_evaluation.attempt_date_created = now
                        update_evaluation_attempt_date_created(get_evaluation._id, now).catch(() => {})
                    }

                    const expiryDays =
                        get_evaluation.attempt_expiry_minutes > 0
                            ? get_evaluation.attempt_expiry_minutes / 1440
                            : get_evaluation.attempt_expiry_days ?? 7
                    const expiryMs = expiryDays * 24 * 60 * 60 * 1000
                    const attemptStart = new Date(get_evaluation.attempt_date_created)
                    const expiryDate = new Date(attemptStart.getTime() + expiryMs)
                    const now = new Date()
                    console.log('[ExpiryCheck] attempt_date_created:', get_evaluation.attempt_date_created)
                    console.log('[ExpiryCheck] expiryDays:', expiryDays, '| expiryDate:', expiryDate.toISOString())
                    console.log('[ExpiryCheck] now:', now.toISOString(), '| expired:', now > expiryDate)
                    if (now > expiryDate) {
                        console.log('[ExpiryCheck] Intento expirado — limpiando partial_anmswers y current_attempt_id')
                        get_evaluation.partial_anmswers = []
                        get_evaluation.current_attempt_id = null
                        get_evaluation.attempts_count = (parseInt(get_evaluation.attempts_count) || 0) + 1
                        increment_evaluation_attempts_count(db, get_evaluation._id).catch(() => {})
                        update_evaluation_attempt_date_created(get_evaluation._id, null).catch(() => {})
                        update_evaluation_partial_answers(get_evaluation._id, []).catch(() => {})
                        update_evaluation_current_attempt_id(get_evaluation._id, null).catch(() => {})
                    }
                }

                let evalPartialAnswers = []
                if (get_evaluation.partial_anmswers) {
                    try {
                        evalPartialAnswers =
                            typeof get_evaluation.partial_anmswers === 'string'
                                ? JSON.parse(get_evaluation.partial_anmswers)
                                : Array.isArray(get_evaluation.partial_anmswers)
                                  ? get_evaluation.partial_anmswers
                                  : []
                    } catch {}
                }
                if (evalPartialAnswers.length > 0) {
                    // Seed del ref local para tracking en sesión
                    evalPartialAnswers.forEach((id) =>
                        submittedQuestionsRef.current.add(id),
                    )
                    // Filtrar preguntas ya respondidas
                    get_evaluation.questions = get_evaluation.questions.filter(
                        (q) => !evalPartialAnswers.includes(q._id),
                    )
                }

                // Fijar el offset inicial para el contador (no cambia mientras se avanza)
                initialSubmittedCountRef.current = submittedQuestionsRef.current.size

                // Restaurar attempt_id activo si la evaluación quedó en curso (partial submissions)
                // Validar que sea un ObjectId real (24 hex) para evitar enviar valores corruptos ("0", "null", etc.)
                const isValidAttemptId = (id) => id && /^[a-f0-9]{24}$/i.test(id)
                if (isValidAttemptId(get_evaluation.current_attempt_id)) {
                    attemptIdRef.current = get_evaluation.current_attempt_id
                }

                setCurrentEvaluation(get_evaluation)

                // Re-entrada con partial submission activo: arrancar desde la primera pregunta pendiente
                if (
                    get_evaluation.allow_partial_submission &&
                    submittedQuestionsRef.current.size > 0
                ) {
                    const firstPendingIdx = get_evaluation.questions.findIndex(
                        (q) => !submittedQuestionsRef.current.has(q._id),
                    )
                    if (firstPendingIdx > 0) {
                        setCurrentQuestion(firstPendingIdx)
                    }
                }

                // console.log('[Survey] currentEvaluation set to:', get_evaluation)
                if (
                    course_id != null &&
                    currentCourse_store == null &&
                    !courseItem
                ) {
                    console.log(
                        '-----------------------------------[Survey] Fetching course with ID:',
                        course_id,
                    )
                    //TODO: Hacer fetch a curso en web
                    let get_course = await get_course_by_id(db, course_id)
                    console.log(
                        '---------------------[Survey] get_course from DB:',
                        get_course,
                    )
                    if (!get_course || !get_course._id || get_course == null) {
                        // hago un fetch
                        console.log('entro al ifif')

                        get_course = await getCourseByIdFetch(course_id)
                        console.log(
                            '1064 ---------------------[Survey] get_course from fetch:',
                            get_course,
                        )
                    }

                    setCourse(get_course)
                }
            } else {
                console.warn(
                    '[Survey] Evaluation not found in DB or courseItem; closing',
                )
                return closeToCourse('evaluation_not_found')
            }
        } catch (error) {
            console.error('Error fetching evaluation:', error)
            closeToCourse('evaluation_fetch_error')
        }
    }

    const getCourseByIdFetch = async (course_id) => {
        console.log(
            '-----------------------------------🚀 ~ getCourseByIdFetch ~ course_id:',
            course_id,
        )
        let course = null
        try {
            const session = await fetchAuthSession()
            const authToken = session.tokens?.accessToken?.toString() || ''

            if (!authToken) {
                warn('CTA', 'No auth token available for course fetch')
            }

            const data = await request_get_training_courses_home({ authToken })
            console.log('---------- 🚀 ~ getCourseByIdFetch ~ data:', data)

            if (data && data.status == 1 && data.single) {
                const dataSingle = data.single
                const categories = dataSingle.categories ? dataSingle.categories : []

                if (categories.length > 0) {
                    // voy a recorrer categorias y sus cursos hasta encontrar el curso en base al id
                    for (let i = 0; i < categories.length; i++) {
                        const category = categories[i]
                        if (category.repository && category.repository.length > 0) {
                            for (let j = 0; j < category.repository.length; j++) {
                                const courseItem = category.repository[j]
                                if (
                                    courseItem._id.toString() ===
                                    course_id.toString()
                                ) {
                                    course = courseItem
                                    console.log(
                                        '---------- 🚀 ~ getCourseByIdFetch ~ found course:',
                                        course,
                                    )
                                    break
                                }
                            }
                        }
                        if (course) {
                            break
                        }
                    }
                }
            }
            // return course
        } catch (error) {
            console.error('Error fetching course by ID - getCourseByIdFetch:', error)
        } finally {
            return course
        }
    }

    const complete_blanks = (index, value) => {
        let update_option = false
        console.log(
            '🟢 estoy en complete_blank index:',
            index,
            'value:',
            value,
            'positionLabel',
            positionLabel,
            'labelComplet:',
            labelComplet,
        )
        const question = currentEvaluation.questions[currentQuestion]
        const text = question.title
        const modifiedText = text.replace(/_+/g, 'none')
        let blanks_original = modifiedText.split(' ')

        if (labelComplet.length > 0) {
            blanks_original = labelComplet
        }

        if (index !== null) {
            if (value !== '') {
                blanks_original[index] = value
            } else {
                //aca es cuando borra o selecciona donde quire  completar
                //primero deselecciono el que estaba seleccionado
                let prev_option = blanks_original[index]
                if (prev_option) {
                    console.log('🚀 ~ Survey ~ prev_option:', prev_option)
                    let find_question = question.secondary_actions.find(
                        (option) => option.label == prev_option,
                    )
                    if (find_question) {
                        // console.log('🚀 ~ =========>>> ~ find_question:', find_question)
                        selectOption(find_question._id, false)
                    }
                }
                //limpio el campo
                setpositionLabel(index)
                blanks_original[index] = 'none'
            }
        } else {
            // aca me llega el value pero no el index
            //aca no llega la posicion
            if (positionLabel !== null) {
                if (blanks_original[positionLabel]) {
                    blanks_original[positionLabel] = value.label
                    setpositionLabel(null)
                    update_option = true
                }
            } else {
                const find_index = blanks_original.indexOf('none')
                if (find_index !== -1) {
                    blanks_original[find_index] = value.label
                    update_option = true
                }
            }
        }

        // Actualiza el estado selectedOptions si es necesario
        if (update_option) {
            const selectedOptionId = value?._id
            selectOption(selectedOptionId, true)
        }

        setlabelComplet([...blanks_original])
        setSelectedOptions((prevState) => ({
            ...prevState,
            // [question._id]: [...blanks_original],
            [question._id]: blanks_original.map((word, idx) =>
                word === 'none'
                    ? 'none'
                    : question.secondary_actions.find((opt) => opt.label === word) ||
                      word,
            ),
        }))
    }

    const selectOption = (optionId, is_selected) => {
        const question = currentEvaluation.questions[currentQuestion]

        // Actualiza el estado is_selected de la opción seleccionada
        const updatedSecondaryActions = question.secondary_actions.map((option) => {
            if (option._id === optionId) {
                return {
                    ...option,
                    is_selected: is_selected,
                }
            }
            return option
        })

        // Actualiza el estado de la evaluación con la pregunta actualizada
        setCurrentEvaluation({
            ...currentEvaluation,
            questions: currentEvaluation.questions.map((q, index) => {
                // Solo actualiza la pregunta actual
                if (index === currentQuestion) {
                    return {
                        ...question,
                        secondary_actions: updatedSecondaryActions,
                    }
                }
                return q
            }),
        })
    }

    const showBackModal = (allow_partial_submission) => {
        if (isWeb && isWebModal) {
            // Delega al wrapper del modal (botón X ya abre confirm)
            // o se podría disparar un handler local si es necesario
            if (typeof closeWebModal === 'function') {
                // Mostrar confirmación nativa del navegador cuando no tenemos acceso al wrapper
                const shouldClose = confirm(
                    languageFile.your_answers_will_not_be_saved,
                )
                if (shouldClose) closeBackModal(true)
            }
        } else {
            const canRepeatVal = !!currentEvaluation?.can_repeat
            const maxRetryVal = currentEvaluation?.max_retry_attempts
                ? parseInt(currentEvaluation.max_retry_attempts)
                : null
            const attemptsCountVal = parseInt(currentEvaluation?.attempts_count) || 0
            const currentAttemptNum = attemptsCountVal + 1
            let image = null
            let retryMsg = ''
            if (!canRepeatVal) {
                retryMsg = 'No puedes reintentar esta evaluación.'
                image = require('../../../../assets/evaluations/testRetryLimit.png')
            } else if (maxRetryVal === null) {
                retryMsg = `Puedes reintentar esta evaluación las veces que quieras.\n\nEstás en el intento ${currentAttemptNum}.`
            } else {
                retryMsg = `Puedes reintentar esta evaluación ${maxRetryVal} veces.\n\nEstás en el intento ${currentAttemptNum} de ${maxRetryVal}.`
                image = require('../../../../assets/evaluations/testRetryLimit.png')
            }

            if (allow_partial_submission) {
                let description = !isSP
                    ? `Las respuestas se guardarán parcialmente y podrás continuar luego.\n${retryMsg}`
                    : `Tus respuestas se guardarán por 7 días para poder continuar. Luego tendrás que comenzar de nuevo y perderás un intento.\n${retryMsg}`
                openBottomSheet(
                    <BottomSheetBackAlert
                        closeBottomSheet={(i) => closeBackModal(i)}
                        description={description}
                        image={image}
                    />,
                )
            } else {
                openBottomSheet(
                    <BottomSheetBackAlert
                        closeBottomSheet={(i) => closeBackModal(i)}
                        image={image}
                    />,
                )
            }
        }
    }

    const closeBackModal = (goBack) => {
        console.log('🚀 ~ closeBackModal ~ :')
        // closeBottomSheet(true)
        // if (!goBack) return
        // Web modal: cerrar modal y volver al Course/Learning
        console.log('🚀 ~ closeBackModal ~ isWeb:', isWeb, 'isWebModal:', isWebModal)
        if (isWeb && isWebModal && typeof closeWebModal === 'function') {
            closeWebModal({
                course_id: course?._id || route.params.course_id,
                courseItem: route.params.courseItem || course,
            })
            return
        }

        console.log('🚀 ~ closeBackModal ~ goBack:', goBack)

        if (goBack) {
            closeBottomSheet(true)
            navigation.goBack()
        } else {
            closeBottomSheet(true)
        }

        // Mobile/native: resetear stack a 'Main' (MyTabs) para que el footer/tab bar esté visible
        // try {
        //     navigation.dispatch(
        //         CommonActions.reset({
        //             index: 0,
        //             routes: [{ name: 'Main' }],
        //         }),
        //     )
        // } catch (e) {
        //     try {
        //         navigation.navigate('Main')
        //     } catch (e2) {
        //         try {
        //             navigation.goBack()
        //         } catch {}
        //     }
        // }
    }

    const isApprovedEvaluation = (evaluation, answers) => {
        let isApproved = {
            isApproved: false,
            totalScore: 0,
            userScorePercentage: 0,
        }
        try {
            const approvalRate =
                typeof evaluation.approval_rate == 'string'
                    ? parseInt(evaluation.approval_rate)
                    : evaluation.approval_rate
            // console.log('approvalRate - ', approvalRate)
            // console.log('approvalRate - typeof ', typeof approvalRate)
            // console.log('anwers - ', answers)
            // console.log('evaluation - ', evaluation)

            if (!evaluation || !answers) return isApproved

            const questions = evaluation.questions

            let maxPossibleScore = 0
            let totalScore = 0

            questions.forEach((question) => {
                if (answers[question._id.toString()]) {
                    let answer = answers[question._id.toString()]

                    switch (question.input_type[0]?.type) {
                        case 22: // Opción Simple
                        case 28: // single_choise_image
                            const correctAnswer = question.secondary_actions.find(
                                (action) => action.correct === true,
                            )
                            if (
                                correctAnswer != undefined &&
                                correctAnswer.score != undefined
                            ) {
                                maxPossibleScore += correctAnswer.score
                            }

                            const selectedAnswer = answer[0] // Tomar la primera respuesta
                            if (
                                selectedAnswer &&
                                correctAnswer &&
                                selectedAnswer._id === correctAnswer._id.toString()
                            ) {
                                totalScore += correctAnswer.score
                            }
                            break

                        case 23: // Opción Múltiple
                            question.secondary_actions.forEach((action) => {
                                const selectedAnswer = answer.find(
                                    (ans) => ans._id === action._id.toString(),
                                )
                                if (selectedAnswer && selectedAnswer.is_selected) {
                                    totalScore += action.score
                                }
                                if (action.correct) {
                                    maxPossibleScore += action.score
                                }
                            })
                            break

                        case 5: // Tipo Input
                            const selectedInputAnswer = answer[0] // Tomar la primera respuesta
                            console.log(
                                '🚀 ~selectedInputAnswer:',
                                selectedInputAnswer,
                            )
                            question.secondary_actions.forEach((action) => {
                                const userText = (selectedInputAnswer?.input || '')
                                    .toString()
                                    .toLowerCase()
                                if (
                                    userText.includes(
                                        (action.label || '')
                                            .toString()
                                            .toLowerCase(),
                                    ) &&
                                    action.correct
                                ) {
                                    totalScore += action.score
                                }
                                maxPossibleScore += action.score
                                //console.log(' --------> maxPossibleScore case 5 <--------',maxPossibleScore);
                            })
                            break

                        case 34: // Complete Blanks
                            maxPossibleScore += question.score
                            //console.log(' --------> maxPossibleScore case 34 <--------',maxPossibleScore);
                            const correctWords = (question.text_correct || '')
                                .toString()
                                .toLowerCase()
                                .trim()
                            // normalizo el array de respuesta para soportar strings u objetos con label/input
                            const respuestaComoString = (
                                Array.isArray(answer) ? answer : [answer]
                            )
                                .map((item) => {
                                    if (typeof item === 'string') return item
                                    if (item && typeof item === 'object') {
                                        if (item.label) return item.label
                                        if (item.input) return item.input
                                    }
                                    return ''
                                })
                                .join(' ')
                                .toLowerCase()
                                .trim()
                            if (respuestaComoString === correctWords) {
                                totalScore += question.score
                            }
                            break

                        default:
                            // Manejar otros tipos de pregunta
                            break
                    }
                }
            })

            console.log(' --------> maxPossibleScore <--------', maxPossibleScore)
            console.log(' --------> approvalRate <--------', approvalRate)
            console.log(' --------> totalScore <--------', totalScore)
            const userScorePercentage =
                maxPossibleScore > 0 ? (totalScore * 100) / maxPossibleScore : 0
            console.log(
                ' --------> userScorePercentage <--------',
                userScorePercentage,
            )
            console.log(
                ' --------> userScorePercentage <--------typeof ',
                typeof userScorePercentage,
            )

            if (userScorePercentage >= approvalRate) {
                console.log(' --------> Aprobado <--------')
                isApproved = {
                    isApproved: true,
                    totalScore: totalScore,
                    userScorePercentage: userScorePercentage,
                }
            } else {
                isApproved = {
                    isApproved: false,
                    totalScore: totalScore,
                    userScorePercentage: userScorePercentage,
                }
            }

            return isApproved
        } catch (error) {
            console.log(
                '🚀 ~ file: survey.js ~ line 78 ~ isApprovedEvaluation ~ error',
                error,
            )
            return false
        }
    }

    // Calcula los IDs de preguntas incorrectas de forma local (para persistir failed_questions offline)
    const getFailedQuestionsOffline = (evaluation, answers) => {
        const failedIds = []
        try {
            evaluation.questions.forEach((question) => {
                const answer = answers[question._id.toString()]
                if (!answer) {
                    failedIds.push(question._id)
                    return
                }
                let isCorrect = false
                switch (question.input_type[0]?.type) {
                    case 22: // single choice
                    case 28: // single choice image
                        const correctAnswer = question.secondary_actions.find(
                            (a) => a.correct === true,
                        )
                        const selectedAnswer = answer[0]
                        isCorrect =
                            correctAnswer &&
                            selectedAnswer &&
                            selectedAnswer._id === correctAnswer._id.toString()
                        break
                    case 23: // multiple choice — correcto si ganó todos los puntos posibles
                        let earned = 0
                        let possible = 0
                        question.secondary_actions.forEach((action) => {
                            if (action.correct) possible += action.score
                            const sel = answer.find(
                                (ans) => ans._id === action._id.toString(),
                            )
                            if (sel && sel.is_selected) earned += action.score
                        })
                        isCorrect = possible > 0 && earned >= possible
                        break
                    case 5: // input
                        const inputText = (answer[0]?.input || '')
                            .toString()
                            .toLowerCase()
                        isCorrect = question.secondary_actions.some(
                            (a) =>
                                a.correct &&
                                inputText.includes(
                                    (a.label || '').toString().toLowerCase(),
                                ),
                        )
                        break
                    case 34: // complete blanks
                        const correctWords = (question.text_correct || '')
                            .toString()
                            .toLowerCase()
                            .trim()
                        const respStr = (Array.isArray(answer) ? answer : [answer])
                            .map((item) => {
                                if (typeof item === 'string') return item
                                if (item && typeof item === 'object')
                                    return item.label || item.input || ''
                                return ''
                            })
                            .join(' ')
                            .toLowerCase()
                            .trim()
                        isCorrect = respStr === correctWords
                        break
                    default:
                        isCorrect = true
                        break
                }
                if (!isCorrect) failedIds.push(question._id)
            })
        } catch {}
        return failedIds
    }

    useEffect(() => {
        // console.log(
        //     '[Survey] useEffect triggered, calling fetchEvaluation with route:',
        //     route,
        // )
        // fetchEvaluation()

        console.log('📊 [Survey] Initializing...')
        console.log('  - Course from store:', currentCourse_store?._id)
        console.log('  - Course from params:', courseItem?._id)

        // Priorizar store sobre params
        if (currentCourse_store?._id) {
            setCourse(currentCourse_store)
        } else if (courseItem?._id) {
            setCourse(courseItem)
        }
        // else if (course_id) {
        //     // Fallback: intentar fetch
        // }
        fetchEvaluation()
    }, [route])

    // Interceptar back físico en Android cuando se muestran resultados para evitar reabrir Survey
    useEffect(() => {
        if (Platform.OS !== 'web' && showScore) {
            const onBack = () => {
                try {
                    navigation.dispatch(
                        CommonActions.reset({
                            index: 0,
                            routes: [{ name: 'Main' }],
                        }),
                    )
                } catch (e) {
                    try {
                        navigation.navigate('Main')
                    } catch {}
                }
                return true
            }
            const sub = BackHandler.addEventListener('hardwareBackPress', onBack)
            return () => sub.remove()
        }
    }, [showScore])

    const renderQuestionContent = () => {
        switch (currentEvaluation.questions[currentQuestion]?.input_type[0].title) {
            case 'comments':
                return (
                    <View style={styles.optionsContainer}>
                        <View style={styles.inputContainer}>
                            <TextInput
                                onChangeText={(text) => handleAnswer(text)}
                                style={styles.inputField}
                                placeholder={languageFile.write_here}
                                placeholderTextColor={theme.colors.mediumGray}
                                multiline={true}
                            />
                        </View>
                    </View>
                )
            case 'multiple_choice_image':
            case 'single_choice_image':
                let content =
                    currentEvaluation.questions[currentQuestion]
                        ?.secondary_actions || []
                let isContentPair = isPair(content.length)
                if (!isContentPair) {
                    let ghostItem = { _id: 'ghost' }
                    content.push(ghostItem)
                }
                return (
                    <View style={styles.optionsContainer}>
                        <View style={styles.imageContainer}>
                            {content
                                .sort((a, b) =>
                                    a._id === 'ghost'
                                        ? 1
                                        : b._id === 'ghost'
                                          ? -1
                                          : 0,
                                )
                                .map((item) => {
                                    if (item._id === 'ghost') {
                                        return (
                                            <View
                                                key={item._id}
                                                style={[
                                                    styles.optionImage,
                                                    { opacity: 0 },
                                                ]}
                                            ></View>
                                        )
                                    }
                                    let highlight = optionsToHighlight.includes(
                                        item._id,
                                    )
                                    let correctNotSelected =
                                        optionsToHighlight.length > 0 &&
                                        !optionsToHighlight.includes(item._id) &&
                                        item.correct
                                    return (
                                        <TouchableOpacity
                                            key={item._id}
                                            onPress={() => handleAnswer(item)}
                                        >
                                            <RenderImage
                                                item={item}
                                                path={path}
                                                highLight={highlight}
                                                correctNotSelected={
                                                    correctNotSelected
                                                }
                                            />
                                        </TouchableOpacity>
                                    )
                                })}
                        </View>
                    </View>
                )
            case 'complete_blanks':
                const question = currentEvaluation.questions[currentQuestion]
                const text = question['title']
                const modifiedText = text.replace(/_+/g, 'none')
                const blanks = modifiedText.split(' ')
                // const options = currentEvaluation.questions[currentQuestion].secondary_actions.map((option) => option)
                return (
                    <View style={styles.optionsContainer}>
                        <View style={styles.optionsSubContainer}>
                            {blanks.map((part, index) => {
                                return (
                                    <View
                                        key={index}
                                        style={styles.flexDirectionRow}
                                    >
                                        {part === 'none' ? (
                                            <TouchableOpacity
                                                onPress={() =>
                                                    complete_blanks(index, '')
                                                }
                                                style={
                                                    labelComplet[index]
                                                        ? labelComplet[index] !=
                                                          'none'
                                                            ? styles.complete
                                                            : styles.chip
                                                        : styles.chip
                                                }
                                            >
                                                <Text
                                                    style={styles.chipText}
                                                    numberOfLines={2}
                                                >
                                                    {labelComplet[index]
                                                        ? labelComplet[index] !=
                                                          'none'
                                                            ? labelComplet[index]
                                                            : ''
                                                        : ''}
                                                </Text>
                                            </TouchableOpacity>
                                        ) : (
                                            <Text style={styles.optionText}>
                                                {part}{' '}
                                            </Text>
                                        )}
                                    </View>
                                )
                            })}
                        </View>

                        {/*<Text style={styles.optionTextDetails}>{currentEvaluation.questions[currentQuestion]?.input_type[0].title}</Text>*/}

                        <View style={styles.completeBlanksContainer}>
                            {currentEvaluation?.questions[
                                currentQuestion
                            ]?.secondary_actions.map((option, optionIndex) => (
                                <TouchableOpacity
                                    key={optionIndex}
                                    onPress={() => complete_blanks(null, option)}
                                    style={[
                                        styles.optionContainer,
                                        option?.is_selected && styles.selectedOption,
                                    ]}
                                    disabled={option?.is_selected}
                                >
                                    <Text
                                        style={[
                                            styles.options,
                                            option?.is_selected &&
                                                styles.selectedOptionText,
                                        ]}
                                    >
                                        {option.label}
                                    </Text>
                                </TouchableOpacity>
                            ))}
                        </View>
                    </View>
                )

            default:
                // Renderizar las opciones para preguntas de opción única o múltiple
                const options = currentEvaluation.questions[
                    currentQuestion
                ]?.secondary_actions.map((item) => {
                    let highlight = optionsToHighlight.includes(item._id)
                    let correctNotSelected =
                        optionsToHighlight.length > 0 &&
                        !optionsToHighlight.includes(item._id) &&
                        item.correct
                    let highLightContainerStyle = item.correct
                        ? styles.highLightOptionCorrectContainer
                        : styles.highLightOptionIncorrectContainer
                    let highLightTextStyle = item.correct
                        ? styles.highLightOptionCorrectText
                        : styles.highLightOptionIncorrectText
                    return (
                        <TouchableOpacity
                            onPress={() => handleAnswer(item)}
                            style={[
                                styles.optionContainer,
                                item.is_selected && styles.selectedOption,
                                correctNotSelected &&
                                    styles.correctNotSelectedContainer,
                                highlight && highLightContainerStyle,
                            ]}
                            key={item.label}
                        >
                            <Text
                                style={[
                                    styles.options,
                                    item.is_selected && styles.selectedOptionText,
                                    correctNotSelected &&
                                        styles.correctNotSelectedText,
                                    highlight && highLightTextStyle,
                                ]}
                            >
                                {item.label}
                            </Text>
                        </TouchableOpacity>
                    )
                })
                return <View style={styles.optionsContainer}>{options}</View>
        }
    }

    const openBackModal = () => {
        console.log(
            'openBackModal - currentEvaluation = > ',
            JSON.stringify(currentEvaluation),
        )

        const allow_partial_submission = currentEvaluation?.allow_partial_submission

        console.log(
            'openBackModal - allow_partial_submission => ',
            allow_partial_submission,
        )

        showBackModal(allow_partial_submission)

        // if (allow_partial_submission) {
        //     console.log('openBackModal - allow_partial_submission is true, abro modal nuevo...')
        //     showBackModal()

        // } else {
        //     console.log('openBackModal - allow_partial_submission is false, abro modal de siempre...')
        //     showBackModal()
        // }
    }
    return (
        <View style={styles.container}>
            {isLoading ? (
                <Loader />
            ) : (
                <>
                    {currentEvaluation && currentEvaluation.questions ? (
                        showScore ? (
                            <ShowBottons />
                        ) : (
                            <LinearGradient
                                style={{
                                    ...styles.container,
                                    paddingHorizontal: isWebModal ? '5%' : '0%',
                                    paddingTop: isWebModal ? '6%' : insets.top,
                                    paddingBottom: '1%',
                                    pointerEvents: waiting ? 'none' : null,
                                }}
                                colors={[
                                    theme.colors.linearGradientEnd,
                                    theme.colors.linearGradientStart,
                                ]}
                                start={{ x: 0, y: 1 }}
                                end={{ x: 0, y: 0 }}
                            >
                                {/* Ocultar botón back cuando está en modal web (el modal tiene su propio botón X) */}
                                {!isWebModal && (
                                    <TouchableOpacity
                                        style={styles.backIcon}
                                        onPress={openBackModal}
                                    >
                                        <Feather
                                            name='arrow-left'
                                            size={20}
                                            color={colorIcon}
                                        />
                                    </TouchableOpacity>
                                )}
                                <View
                                    style={[
                                        { flex: 1 },
                                        isWeb && {
                                            maxWidth: 692,
                                            alignSelf: 'center',
                                        },
                                    ]}
                                >
                                    <Text style={styles.titleEvaluationText}>
                                        {currentEvaluation.name ?? ''}
                                    </Text>
                                    <Text style={styles.optionTextDetails}>
                                        {languageFile.evaluation}
                                        {initialSubmittedCountRef.current +
                                            currentQuestion +
                                            1}
                                        {languageFile.of}
                                        {initialSubmittedCountRef.current +
                                            currentEvaluation.questions.length}
                                        {/* {'==> ID: => ' + currentEvaluation?.questions[currentQuestion]?._id || 'Loading'} */}
                                    </Text>
                                    <ScrollView
                                        showsVerticalScrollIndicator={false}
                                        ref={scrollRef}
                                    >
                                        <View style={styles.parent}>
                                            <View style={styles.questionContainer}>
                                                {currentEvaluation.questions[
                                                    currentQuestion
                                                ]?.input_type[0].title !==
                                                    'complete_blanks' && (
                                                    <View>
                                                        <Text
                                                            style={styles.optionText}
                                                        >
                                                            {
                                                                currentEvaluation
                                                                    .questions[
                                                                    currentQuestion
                                                                ]?.title
                                                            }
                                                        </Text>
                                                        {currentEvaluation.questions[
                                                            currentQuestion
                                                        ]?.media &&
                                                            currentEvaluation
                                                                .questions[
                                                                currentQuestion
                                                            ]?.media != '' && (
                                                                <View
                                                                    style={
                                                                        styles.container_image
                                                                    }
                                                                >
                                                                    <Image
                                                                        source={{
                                                                            uri: currentEvaluation
                                                                                .questions[
                                                                                currentQuestion
                                                                            ]?.media,
                                                                        }}
                                                                        style={[
                                                                            {
                                                                                borderRadius: 10,
                                                                                margin: 5,
                                                                                width: '80%',
                                                                                aspectRatio: 1,
                                                                            },
                                                                            isWeb && {
                                                                                width: 250,
                                                                            },
                                                                        ]}
                                                                    />
                                                                </View>
                                                            )}
                                                    </View>
                                                )}
                                                {renderQuestionContent()}
                                                <View style={styles.buttonContainer}>
                                                    <TouchableOpacity
                                                        onPress={() =>
                                                            handleNextQuestion()
                                                        }
                                                        style={[
                                                            styles.borderButton,
                                                            {
                                                                backgroundColor:
                                                                    theme.colors
                                                                        .colorSecondary,
                                                            },
                                                        ]}
                                                    >
                                                        <Text
                                                            style={[
                                                                styles.borderButtonText,
                                                            ]}
                                                        >
                                                            {languageFile.confirm}
                                                        </Text>
                                                    </TouchableOpacity>
                                                </View>
                                            </View>
                                        </View>
                                    </ScrollView>
                                </View>
                            </LinearGradient>
                        )
                    ) : (
                        <Text style={styles.optionText}>
                            {languageFile.loading_evaluation}
                        </Text>
                    )}
                    {showInterModal && (
                        <InterModal
                            name={currentEvaluation.name ?? ''}
                            correct={allCorrect}
                            text={modal_text}
                            next={() => setNextQuestion()}
                        />
                    )}
                </>
            )}
        </View>
    )
}

const RenderImage = ({ item, path, highLight, correctNotSelected }) => {
    const [newMedia, setNewMedia] = useState(item.media)

    useEffect(() => {
        const fetchMedia = async () => {
            const mediaLocal = path ? await searchFile(item.media, path) : item.media
            setNewMedia(mediaLocal)
        }
        fetchMedia()
    }, [item.media, path])

    const imageOverlay = () => {
        const selectedIcon = require('../../../../assets/gamification/gamif_selected.png')
        const checkIcon = require('../../../../assets/gamification/gamif_check.png')
        const wrongIcon = require('../../../../assets/gamification/gamif_wrong.png')
        let overlay = null
        if (item.is_selected) {
            overlay = {
                icon: selectedIcon,
                color: GamificationTheme.imageSelectedIconColor,
            }
        }
        if (correctNotSelected) {
            overlay = {
                icon: checkIcon,
                color: GamificationTheme.imageCorrectNotSelectedIconColor,
            }
        }
        if (highLight) {
            if (item.correct) {
                overlay = {
                    icon: checkIcon,
                    color: GamificationTheme.imageCorrectIconColor,
                }
            } else {
                overlay = {
                    icon: wrongIcon,
                    color: GamificationTheme.imageIncorrectIconColor,
                }
            }
        }
        if (overlay === null) return null
        return (
            <View
                style={{
                    flex: 1,
                    backgroundColor: 'rgba(255, 255, 255, 0.7)',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Image
                    source={overlay.icon}
                    style={{ width: 44, height: 44, tintColor: overlay.color }}
                />
            </View>
        )
    }

    return (
        <ImageBackground
            source={{ uri: newMedia ? newMedia : placeholderLearning }}
            style={[styles.optionImage]}
        >
            {imageOverlay()}
        </ImageBackground>
    )
}

const InterModal = ({ name, correct, text, next }) => {
    return (
        <View
            style={{
                position: 'absolute',
                backgroundColor: 'rgba(0,0,0,0.5)',
                width: '100%',
                height: '100%',
                justifyContent: 'center',
                alignItems: 'center',
                color: 'white',
            }}
        >
            <View style={[styles.modalBox, isWeb && { maxWidth: 400 }]}>
                <Image
                    style={[
                        styles.IntermodalImage,
                        isWeb && { width: 132, height: 132, marginBottom: 16 },
                    ]}
                    source={
                        correct
                            ? require('../../../../assets/trivia/CheckmarkTrivia.png')
                            : require('../../../../assets/trivia/errorTrivia.png')
                    }
                    resizeMode='contain'
                    resizeMethod='resize'
                />
                <Text style={styles.modalText}>{text}</Text>
                {/* <Text style={styles.modalText2}>{correct ? 'Correcto' : 'Incorrecto'}</Text> */}
                <Text style={styles.modalText2}>
                    {correct
                        ? '¡Bien hecho! 🎉 Seguí así y demostrá todo tu conocimiento.'
                        : '¡Ups! 😕 No era la respuesta correcta, pero no te rindas. Aprendé de esta y preparate para la próxima pregunta. ¡Vos podés! 🚀'}
                </Text>
                <Text style={styles.modalText3}>{name}</Text>
                <TouchableOpacity onPress={() => next()}>
                    <Text
                        style={[
                            styles.mainButton,
                            isWeb && {
                                fontSize: 18,
                                paddingHorizontal: 36,
                                paddingVertical: 12,
                            },
                        ]}
                    >
                        Siguiente
                    </Text>
                </TouchableOpacity>
            </View>
        </View>
    )
}
